import React from 'react';
import { View, StyleSheet, useWindowDimensions } from 'react-native';
import { Colors } from '../../constants/Colors';

const SkeletonLoader = ({ tiny = false, numColumns = 2 }) => {
  const { width } = useWindowDimensions();
  const CARD_WIDTH = (width - 40) / numColumns;
  const rowsPerColumn = tiny ? 1 : 2;

  const cardStyle = { width: CARD_WIDTH, backgroundColor: '#f0f0f0', borderRadius: 8, padding: 10, gap: 8 };
  const imageStyle = { width: '100%' as const, height: CARD_WIDTH, backgroundColor: '#e0e0e0', borderRadius: 4 };

  const CardItem = () => (
    <View style={cardStyle}>
      <View style={imageStyle} />
      <View style={styles.title} />
      <View style={styles.description} />
      <View style={styles.price} />
    </View>
  );

  return (
    <View style={styles.container}>
      {Array.from({ length: numColumns }).map((_, colIndex) => (
        <View key={colIndex} style={styles.column}>
          {Array.from({ length: rowsPerColumn }).map((_, rowIndex) => (
            <CardItem key={rowIndex} />
          ))}
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    padding: 10,
    gap: 10,
  },
  column: {
    flex: 1,
    gap: 10,
  },
  title: {
    width: '80%',
    height: 16,
    backgroundColor: '#e0e0e0',
    borderRadius: 4,
  },
  description: {
    width: '60%',
    height: 12,
    backgroundColor: '#e0e0e0',
    borderRadius: 4,
  },
  price: {
    width: '40%',
    height: 14,
    backgroundColor: '#e0e0e0',
    borderRadius: 4,
  },
});

export default SkeletonLoader;
